var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { PersonCell } from './person-cell';
import { useLang } from '../hooks/use-lang';
import { EntityValue } from './entity-value';
import { entityTypeNameFor } from '@shapeable/utils';
export var EntityConversationBannerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n  "])), theme.COLOR('line-subtle'))
});
var FollowControlsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ModeratorStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled(EntityValue)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  // FollowControls: styled(EntityFollowControls)`${FollowControlsStyles}`,
  Moderator: styled(PersonCell)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ModeratorStyles)
};
export var EntityConversationBanner = function (props) {
  var className = props.className,
    entity = props.entity;
  // const definition = useEntityDefinition(entity);
  var entityType = entityTypeNameFor(entity);
  var baseTemplate = entityType === 'Person' ? 'Conversation Wall' : '%s Conversation';
  // const title = sprintf(baseTemplate, definition.label);
  var t = useLang();
  return React.createElement(My.Container
  // title={title}
  , {
    // title={title}
    className: className,
    entity: entity
  });
};
EntityConversationBanner.defaultProps = EntityConversationBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;